import {PageService, PreviewService,MovieService} from 'hasta-la-vista-middleware-api/service'
import MetaData from  '../../../mixins/meta-data.js'

export default {

    mixins: [MetaData],

    data() {
        return {
            loading: true,
            competitions: []
        }
    },

    methods: {
        getAsyncData(){
            // console.log()
            this.metaTitle = 'Competitions | Win Exciting Prizes'
            this.metaDescription = 'Attention movie-lovers: take a look at the competitions we are currently running. Enter today and stand a chance to win exciting prizes.'
            this.$emit('updateHead');
        }
    },

    created() {
        this.loading = true
        Promise.all([ MovieService.getMovies(),PageService.getCompetitions()]).then(([movies,response])=> {
            this.competitions = PreviewService.addPreviewToContentArrayIfAvailable('competition', response.data)
            this.competitions.forEach((el)=> {
                if (el.related_movie) {
                    el.movie = movies.findById(el.related_movie)
                }
                if (el.mobile_image && el.image)
                    el.srcsets = el.mobile_image.url + ' 700w, ' + el.image.url + ' 2000w'
            });
            this.getAsyncData()
            this.loading = false
        })
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/competitions/competitions.js